import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './campaign_balance.less'
import { getI18n } from 'client/i18n'
import { BodyText } from '@paypalcorp/pp-react'
import { formatMoney } from 'client/griffin'
import Separator from 'components/common/separator'

const i18n = getI18n('components/campaign_balance')

class campaign_balance extends React.Component {
  static propTypes = {
    pledge: PropTypes.number,
    withdraw: PropTypes.number,
    campaignId: PropTypes.string,
    currencyCode: PropTypes.string,
    moneyboxAmount: PropTypes.number,
    removeTrailingZeros: PropTypes.bool,
  }

  static defaultProps = {
    removeTrailingZeros: false,
  }

  render() {
    const {
      currencyCode,
      moneyboxAmount,
      pledge,
      removeTrailingZeros,
    } = this.props
    return (
      <div styleName="balance-wrapper">
        <BodyText strong>{i18n('balance')}</BodyText>

        <Separator />

        <div styleName="balance">
          <div styleName="row">
            <div styleName="label">
              <BodyText>{i18n('available')}</BodyText>
            </div>
            <div styleName="value">
              {formatMoney(currencyCode, moneyboxAmount, {
                removeTrailingZeros,
              })}
            </div>
          </div>
          <div styleName="row">
            <div styleName="label">
              <BodyText>{i18n('pledge_by')}</BodyText>
            </div>
            <div styleName="value">
              {formatMoney(currencyCode, pledge, {
                removeTrailingZeros,
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default cssModules(campaign_balance, styles)
